import { render, staticRenderFns } from "./ServiceSwitcher.vue?vue&type=template&id=223cde72&scoped=true&"
import script from "./ServiceSwitcher.vue?vue&type=script&lang=js&"
export * from "./ServiceSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSwitcher.vue?vue&type=style&index=0&id=223cde72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223cde72",
  null
  
)

export default component.exports